import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { RequestHelper } from '../../../../../shared/helper/request.helper';
import { NavigationConstant } from '../../../../../shared/constant/navigation.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageConstant } from '@constant/message.constant';
import { LinkajaStorage } from '@shared/storage/linkaja.storage';

@Component({
  selector: 'app-identify-linkaja',
  templateUrl: './linkaja-identify.component.html',
  styleUrls: ['./linkaja-identify.component.css']
})
export class IdentifyLinkAjaComponent implements OnInit {
  form: FormGroup;
  inquiryResponse: any;
  isLoading: boolean;
  isSubmitted: boolean;
  hostname: any = environment.hostName;
  token: any;

  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private linkajaStorage: LinkajaStorage,
    private activeRoute: ActivatedRoute
  ) {
    this.isLoading = false;
    this.isSubmitted = false;
  }

  ngOnInit() {
    this.form = new FormBuilder().group({
      token: [null, Validators.required]
    });
    this.activeRoute.queryParams
    .subscribe(params => {
      console.log(params.id); 
      this.token = params.id;
    }
  );
    console.log(this.token);
    if(this.token){
      this.form.controls['token'].setValue(this.token);
      this.submitInquiry();
    }
   
  }

  submitInquiry() {
    this.isSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    this.apiService.post(environment.apiUrl+'linkaja/process-data', JSON.stringify(this.form.getRawValue())).subscribe((data) => {
      if(!data.hasOwnProperty('ref_num')){
        this.apiService.openDialog(MessageConstant.NOT_FOUND, NavigationConstant.LINKAJA_IDENTIFY);
      } else {
        if(data.on_process){
          this.apiService.openDialog(MessageConstant.ON_PROCESS, NavigationConstant.LINKAJA_IDENTIFY);
        }
        this.linkajaStorage.data = data;
        return this.router.navigate([NavigationConstant.LINKAJA_LOGIN]);
      }
    }, (err) => this.isLoading = false);
    this.isLoading = false;
  }

  home() {
    this.apiService.home();
  }

}